import type { ReactNode } from 'react';

export const symbol_tab_search: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M670-160q-70.83 0-120.42-49.62Q500-259.24 500-330.12t49.62-120.38q49.62-49.5 120.5-49.5t120.38 49.58Q840-400.83 840-330q0 26-6.5 52T810-232l89 89q9 9 9 21t-9 21q-9 9-21 9t-21-9l-89-89q-21 17-46.5 23.5T670-160Zm78-91.86q32-31.86 32-78T748.14-408q-31.86-32-78-32T592-408.14q-32 31.86-32 78T591.86-252q31.86 32 78 32T748-251.86ZM140-220v-340 56-236 520Zm0 60q-24.75 0-42.37-17.63Q80-195.25 80-220v-520q0-24.75 17.63-42.38Q115.25-800 140-800h680q24.75 0 42.38 17.62Q880-764.75 880-740v150q0 12.75-8.62 21.37Q862.75-560 850-560H520v-180H140v520h270q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H140Z"
		/>
	</svg>
);
